import {
    AfterViewChecked,
    Component,
    ElementRef,
    EventEmitter,
    OnDestroy,
    OnInit,
    ViewChild, ViewChildren
} from '@angular/core';
import {debounceTime, throttle} from 'rxjs/operators';

import {ModalVisibilityService} from '../../services/modal-visibility.service';
import {MyDialogDataModel} from '../../models/my-dialog-data.model';
import {NgForm} from '@angular/forms';
import {ProjectsStepperComponent} from '../stepper/projects-stepper.component';
import {fromEvent, Subscription} from 'rxjs';
import {EditModalService} from '../../services/edit-modal.service';
import {MyEditModalCloseActionTypeEnum} from '../../enums/my-edit-modal-close-action.enum';
import {MyEditDialogStepsEnum} from '../../enums/my-edit-dialog-steps.enum';
import {EnumUtils} from '../../utils/enum.utils';
import {IProjectService} from '../../services/project.service.interface';
import {SupplyAcquisitionTypeEnum} from '../../enums/supply-acquisition-type.enum';
import {MyContainersTableIdEnum} from '../../enums/my-containers-table-id.enum';
import {ProjectStatusEnum} from '../../enums/project-status.enum';
import {ToastService} from '../../../../shared/services/toast.service';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';


@Component({
    selector: 'app-projects-edit-modal',
    templateUrl: './edit-modal.component.html',
    styleUrls: ['./edit-modal.component.scss']
})
export class ProjectsEditModalComponent extends ModalDialogV3 implements OnInit, AfterViewChecked, OnDestroy {


    public isInitialized = true;
    public dialogModel: MyDialogDataModel;
    public stepEnum = MyEditDialogStepsEnum;

    @ViewChild('userDataForm', {static: false}) userDataForm: NgForm;
    public isUserDataFormValid = false;
    private userDataFormSub: any;


    private scrollEvent: EventEmitter<void> = new EventEmitter();
    private scrollStartSub: Subscription;

    @ViewChildren('scrollArea', {read: ElementRef}) scrollAreas: ElementRef[];

    @ViewChild('stepper') stepper: ProjectsStepperComponent;
    stepIndexToOpenWith: number;
    maxClickableStepIndex: number;
    maxValidatedStepIndex: number;

    private keyDownSub: Subscription;

    private lastScrollToPos: number;

    public MyContainersTableIdEnum = MyContainersTableIdEnum;

    constructor(
                public editModalService: EditModalService,
                private modalVisibilityService: ModalVisibilityService,
                private projectService: IProjectService,
                private toastService: ToastService,
    ) {
        super();

        this.keyDownSub = fromEvent(window, 'keydown').subscribe(ev => {
            this.onWindowKeydown(ev);
        });
    }


    public async ngOnInit() {
        console.log('ngOnInit', this.modalParams);

        this.isInitialized = false;
        try {

            if (this.modalParams.model['project']) {
                this.maxClickableStepIndex = MyEditDialogStepsEnum.STEP6;
            } else {
                this.maxClickableStepIndex = MyEditDialogStepsEnum.STEP1;
            }
            this.maxValidatedStepIndex = MyEditDialogStepsEnum.STEP1 - 1;

            await this.editModalService.init(this.modalParams.model['project']);

            this.dialogModel = this.editModalService.getDialogModel();

            this.editModalService.isDialogOpened = true;
            this.editModalService.currentStepId =
                this.modalParams.model['stepId'] ? this.modalParams.model['stepId'] : MyEditDialogStepsEnum.STEP1;
            this.stepIndexToOpenWith = this.editModalService.currentStepId;


            // this.maxClickableStepIndex = this.isInternalUser() ? MyEditDialogStepsEnum.STEP6 : this.stepIndexToOpenWith;

            if (this.stepIndexToOpenWith === MyEditDialogStepsEnum.STEP6) {
                this.editModalService.updateRPricesBasedApprovalStatusDetailsHelper();
            }

            this.scrollStartSub = this.scrollEvent.pipe(
                // to emit new scrollStart event the scroll events must be paused at least for 300ms
                throttle(ev => this.scrollEvent.pipe(debounceTime(300)))
            ).subscribe(x => this.modalVisibilityService.announceCloseEditDialogModalsRequest('edit-modal_scroll_ngOnInit'));
        } catch (e) {
            console.error(e);
            if (e.toString().includes('Products list is empty or was not loaded')) {
                this.toastService.showError('Die Produktliste ist leer oder konnte nicht geladen werden. Bitte versuchen Sie es später erneut.');
            }

            this.close();
        }

        setTimeout(_ => {
            this.focusNextBtn();
        }, 0);

        this.isInitialized = true;
    }

    public ngAfterViewChecked(): void {
        if (!this.userDataFormSub && this.userDataForm) {
            this.userDataFormSub = this.userDataForm.form.statusChanges.subscribe(value => {
                this.isUserDataFormValid = value === 'VALID';
            });
        }
    }


    public async onCancelBtnClicked() {
        try {
            if (this.dialogModel.project.id) {
                await this.projectService.unlockProjectById(this.dialogModel.project.id);
            }

            this.announceModelChanged(
                {
                    msg: 'refresh projects list',
                    requestedAction: MyEditModalCloseActionTypeEnum.UNLOCK_PROJECT_LIST_ITEM,
                    activeStep: this.editModalService.currentStepId,
                    project: this.dialogModel.project
                });

        } finally {
            this.close();
        }
    }

    public onTopSubmitBtnClicked() {
        // save draft
        // move data form containers to project model the make it ready to save
        // console.log('====== save btn clicked, going to make data ready for rest before the dialog will be closed ======');
        this.editModalService.collectProjectRequestedInfosForRest();

        this.announceModelChanged(
            {
                msg: 'save data',
                requestedAction: MyEditModalCloseActionTypeEnum.SAVE_DRAFT,
                activeStep: this.editModalService.currentStepId,
                project: this.dialogModel.project
            });
    }

    public close() {
        this.editModalService.isDialogOpened = false;
        this.modalVisibilityService.announceCloseEditDialogModalsRequest('edit-modal close');
        super.close();
    }


    private refreshCurrentStepData() {
        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP5) {

            if (this.editModalService.isPrintSmartSupplyAcquisitionType() && !this.editModalService.someMpsDeviceOrderActive()) {
                this.dialogModel.project.supplyAcquisitionType = EnumUtils.getKeyByValue(SupplyAcquisitionTypeEnum, SupplyAcquisitionTypeEnum.NONE);
                // this.editModalService.updateActiveProjectContainerExistenceValidationHelperStatus();

            }

            this.editModalService.refreshAvailablePreselectedPrintSmartDeviceWithSupplyContainers();
            // if (this.editModalService.isPrintSmartSupplyAcquisitionType() && this.isInternalUser()) {
            //     this.editModalService.refreshRequestedPrintSmartSupplyContainers();
            // }

            // refresh arrays which are used for supply selection dialog and contains supplies which we can select from
            this.editModalService.refreshAvailablePreselectedGeneralDeviceWithSupplyContainers();

            // refresh arrays which are used to display already selected supplies on 5. page dialog  ( for kaufen mode)
            this.editModalService.refreshAllRequestedGeneralSupplyContainers();
        }


        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP6) {

            if (this.editModalService.isPrintSmartSupplyAcquisitionType() && !this.editModalService.someMpsDeviceOrderActive()) {
                this.dialogModel.project.supplyAcquisitionType = EnumUtils.getKeyByValue(SupplyAcquisitionTypeEnum, SupplyAcquisitionTypeEnum.NONE);
            }

            if (this.editModalService.isPrintSmartSupplyAcquisitionType()) {
                this.editModalService.refreshRequestedPrintSmartSupplyContainers();
            } else {
                this.editModalService.refreshAvailablePreselectedGeneralDeviceWithSupplyContainers();
                this.editModalService.refreshAllRequestedGeneralSupplyContainers();
            }


            // this.dialogModel.isFirstStepSaveValidationVisibilityForced = true;
            // this.dialogModel.isProjectNameSaveValidationVisibilityForced = true;
            // this.dialogModel.isProjectSubmitValidationVisibilityForced = true;
            this.editModalService.updateRPricesBasedApprovalStatusDetailsHelper();
        }
    }

    public onNextBtnClicked() {
        // console.log('next btn clicked');
        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP1) {
            this.dialogModel.isFirstStepSaveValidationVisibilityForced = true;
            this.editModalService.updateProjectWidgetContact();  // should not be awaited
        }
        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP2) {
            this.dialogModel.isProjectNameSaveValidationVisibilityForced = true;
            if (!this.dialogModel.project.projectName) {
                return;
            }
        }
        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP3) {
            this.dialogModel.isStep3ButtonsValidationVisibilityForced = false;
            if (this.isNextBtnDisabled()) {
                this.dialogModel.isStep3ButtonsValidationVisibilityForced = true;
                return;
            }
        }
        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP4) {
            this.dialogModel.isStep4ButtonsValidationVisibilityForced = false;
            if (this.isNextBtnDisabled()) {
                this.dialogModel.isStep4ButtonsValidationVisibilityForced = true;
                return;

            }
        }


        if (this.editModalService.currentStepId < MyEditDialogStepsEnum.STEP6) {
            this.stepper.next();
            this.editModalService.currentStepId = this.getCurrentStepId();

            if (this.stepper.selectedIndex > this.maxClickableStepIndex) {
                this.maxClickableStepIndex = this.stepper.selectedIndex;
            }
            if (this.stepper.selectedIndex - 1 > this.maxValidatedStepIndex) {
                this.maxValidatedStepIndex = this.stepper.selectedIndex - 1;
            }


            this.refreshCurrentStepData();

            this.scrollToTop(this.stepper.selectedIndex);
        } else {
            this.scrollToBottom(this.stepper.selectedIndex);
        }

        this.stepper.focusNextBtn();
    }

    onPreviousBtnClicked() {
        this.stepper.previous();
        this.editModalService.currentStepId = this.getCurrentStepId();
        this.scrollToTop(this.stepper.selectedIndex);

        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP1) {
            this.stepper.focusNextBtn();
        }
    }

    onDotClicked(indexToGoTo: number) {

        if (this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP1) {
            this.editModalService.updateProjectWidgetContact();  // should not be awaited
        }

        this.stepper.selectedIndex = indexToGoTo;
        if (this.stepper.selectedIndex > this.maxClickableStepIndex) {
            this.maxClickableStepIndex = this.stepper.selectedIndex;
        }
        if (this.stepper.selectedIndex - 1 > this.maxValidatedStepIndex) {
            this.maxValidatedStepIndex = this.stepper.selectedIndex - 1;
        }
        this.editModalService.currentStepId = this.getCurrentStepId();
        this.refreshCurrentStepData();
    }

    public onScroll() {
        this.scrollEvent.next();
    }

    public getCurrentStepId(): MyEditDialogStepsEnum {
        return this.stepper && this.stepper && this.stepper.selectedIndex;
    }

    public onBottomSubmitBtnClicked(): void {

        // this.dialogModel.isProjectSubmitValidationVisibilityForced = true;
        this.dialogModel.isFirstStepSaveValidationVisibilityForced = true;

        if (this.stepper.allStepsAreValid()) {

            // console.log('bottom submit btn clicked, closing edit dialog...');

            this.editModalService.collectProjectRequestedInfosForRest();
            this.announceModelChanged(
                {
                    msg: 'save draft or create new project and send it to brother employee, or resend',
                    requestedAction: MyEditModalCloseActionTypeEnum.SEND_TO_BROTHER,
                    activeStep: this.editModalService.currentStepId,
                    project: this.dialogModel.project
                });


        } else {

            const firstInvalidStep = this.stepper._steps.find(step => {
                return step.stepControl && step.stepControl.invalid;
            });

            this.stepper.selectedIndex = ProjectsStepperComponent.getStepIndexByHtmlId(firstInvalidStep);
            this.editModalService.currentStepId = this.getCurrentStepId();
            this.scrollToTop(this.stepper.selectedIndex);
        }
    }


    private scrollToTop(stepIndex?: number) {
        this.lastScrollToPos = 0;
        this.scrollToPos(this.lastScrollToPos, stepIndex);
    }

    private scrollToBottom(stepIndex?: number) {
        this.lastScrollToPos += 4000;
        this.scrollToPos(this.lastScrollToPos, stepIndex);
    }

    // currently each step must has one scrollArea to make the stepIndex area working correctly

    private scrollToPos(scrollToPos: number, stepIndex?: number) {
        try {
            let i = 0;
            this.scrollAreas.forEach(elementRef => {
                if (stepIndex === undefined || stepIndex === i++) {
                    elementRef.nativeElement.scrollTo({
                        top: scrollToPos,
                        left: 0,
                    });
                }
            });
        } catch {
        }
    }

    public onModalClicked() {
        this.modalVisibilityService.announceCloseEditDialogModalsRequest('edit-modal_clicked');
    }

    public is1StepActive(): boolean {
        return this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP1;
    }

    public is2StepActive(): boolean {
        return this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP2;
    }

    public is3StepActive(): boolean {
        return this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP3;
    }

    public is4StepActive(): boolean {
        return this.editModalService.currentStepId === MyEditDialogStepsEnum.STEP4;
    }


    public isNextBtnDisabled() {
        return (this.is1StepActive() && !this.isUserDataFormValid) ||
            (this.is2StepActive() && !this.dialogModel.project.projectName) ||
            (this.is3StepActive() && this.editModalService.isSomeStep3NoOrderBtnInvalidate()) ||
            (this.is4StepActive() && this.editModalService.isSomeStep4NoOrderBtnInvalid());
    }

    public getStepIdAsString(stepId: MyEditDialogStepsEnum): string {
        return EnumUtils.getKeyByValue(MyEditDialogStepsEnum, stepId);
    }

    public isSubmitButtonVisible(): boolean {
        if (this.stepper && this.stepper.selectedIndex !== undefined) {
            return this.getCurrentStepId() === MyEditDialogStepsEnum.STEP6;
        } else {
            return this.stepIndexToOpenWith === MyEditDialogStepsEnum.STEP6;
        }
    }


    public isTopSaveBtnVisible(): boolean {
        return this.dialogModel && this.dialogModel.project &&
            ProjectStatusEnum[this.dialogModel.project.status] === ProjectStatusEnum.DRAFT;
    }

    private onWindowKeydown(ev: any) {
        if (this.isInitialized && ev.altKey && ev.key === 'w') {
            this.focusNextBtn();
            this.onNextBtnClicked();

        }
    }

    private focusNextBtn(): void {
        // tslint:disable-next-line:no-unused-expression
        this.stepper && this.stepper.focusNextBtn();
    }

    public ngOnDestroy(): void {
        if (this.userDataFormSub) {
            (this.userDataFormSub as Subscription).unsubscribe();
        }
        if (this.scrollStartSub) {
            this.scrollStartSub.unsubscribe();
        }

        if (this.keyDownSub) {
            this.keyDownSub.unsubscribe();
        }
    }

    private projectWasChanged() {
        // console.log('repositor', this.dialogModel.projectRepository);
        // console.log('project', this.dialogModel.project);
        return this.editModalService.compareProjectsAsObjects(this.dialogModel.projectRepository, this.dialogModel.project);
    }

    public forceStepValidation(step: MyEditDialogStepsEnum): boolean {

        return step <= this.maxValidatedStepIndex;
    }

    public isTopSaveBtnDisabled() {
        // different than management app
        return !this.isUserDataFormValid || !(this.dialogModel && this.dialogModel.project && this.dialogModel.project.projectName);
    }
}
